<template>
  <div>
    Viser {{ filteredResidenceNumber }} av {{ totalResidenceNumber }} boliger
  </div>
</template>

<script>
import Residence from '@/models/Residence';


export default {
  name: 'ResidenceCounter',
  computed: {
    totalResidenceNumber() {
      return Residence.query().count();
    },
    filteredResidenceNumber() {
      return Residence.query()
        .whereHas('buildings', query => {
          if (this.selectedBuilding != 'all') {
            query.where('id', this.selectedBuilding);
          }
        })
        .whereHas('availability', query => {
          if (this.residenceStatus != 'all') {
            query.where('slug', this.residenceStatus);
          }
        })
        .whereHas('bedrooms', query => {
          if (this.bedroomState.length > 0) {
            query.where('slug', this.bedroomState);
          }
        })
        .whereHas('bathrooms', query => {
          if (this.bathroomState.length > 0) {
            query.where('slug', this.bathroomState);
          }
        })
        // TODO: Finne på en løsning for filter for bolignivå
        // Filter for bolignivå vil bare slippe igjennom boliger som har minst 1 nivå. Ettersom dette valget ikke er påkrevd for en bolig vil de boligene som ikke har et valgt nivå ikke vises.
        /*.whereHas('levels', query => {
          if (this.selectedLevel != 'all') {
            query.where('slug', this.selectedLevel);
          }
        })*/
        .whereHas('residenceType', query => {
          if (this.selectedResidenceType != 'all') {
            query.where('slug', this.selectedResidenceType);
          }
        })
        .where(residence => {
          if (isNaN(this.minPrice) === false && this.minPrice != 0) {
            return residence.price >= this.minPrice;
          }
        })
        .where(residence => {
          if (isNaN(this.maxPrice) === false && this.maxPrice != 0) {
            return residence.price <= this.maxPrice;
          }
        })
        .where(residence => {
          if (isNaN(this.minSize) === false && this.minSize != 0) {
            return residence.size >= this.minSize;
          }
        })
        .where(residence => {
          if (isNaN(this.maxSize) === false && this.maxSize != 0) {
            return residence.size <= this.maxSize;
          }
        })
        .count();
    },
    selectedBuilding() {
      return this.$store.state.entities.buildings.selectedBuilding;
    },
    residenceStatus() {
      return this.$store.state.entities.residences.residenceStatus;
    },
    selectedLevel() {
      return this.$store.state.entities.residences.selectedLevel;
    },
    selectedResidenceType() {
      return this.$store.state.entities.residences.selectedResidenceType;
    },
    bathroomState() {
      return this.$store.state.entities.residences.bathrooms;
    },
    bedroomState() {
      return this.$store.state.entities.residences.bedrooms;
    },
    minPrice() {
      return this.$store.state.entities.residences.minPrice;
    },
    maxPrice() {
      return this.$store.state.entities.residences.maxPrice;
    },
    minSize() {
      return this.$store.state.entities.residences.minSize;
    },
    maxSize() {
      return this.$store.state.entities.residences.maxSize;
    },
  },
};
</script>